import { IconBase } from "./iconBase.js";
import { Fragment, jsx, jsxs } from "@emotion/react/jsx-runtime";
//#region src/underline.tsx
var Underline = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx("path", {
		d: "M5 21H19",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ jsx("path", {
		d: "M5 3V10C5 13.87 8.13 17 12 17C15.87 17 19 13.87 19 10V3",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})] }) : /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.25 21C4.25 20.5858 4.58579 20.25 5 20.25H19C19.4142 20.25 19.75 20.5858 19.75 21C19.75 21.4142 19.4142 21.75 19 21.75H5C4.58579 21.75 4.25 21.4142 4.25 21Z",
		fill: "currentColor"
	}), /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5 2.25C5.41421 2.25 5.75 2.58579 5.75 3V10C5.75 13.4558 8.54421 16.25 12 16.25C15.4558 16.25 18.25 13.4558 18.25 10V3C18.25 2.58579 18.5858 2.25 19 2.25C19.4142 2.25 19.75 2.58579 19.75 3V10C19.75 14.2842 16.2842 17.75 12 17.75C7.71579 17.75 4.25 14.2842 4.25 10V3C4.25 2.58579 4.58579 2.25 5 2.25Z",
		fill: "currentColor"
	})] })
});
//#endregion
export { Underline };
